import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_CON009_Request,
  IAPI_CON009_Response,
  IAPI_CON016_Request,
  IAPI_CON016_Response,
} from "../../../type/apiType";

// 契約者氏名等変更届・共済契約証書再交付申出参照
const httpAPI_CON009 = async (
  param: IAPI_CON009_Request
): Promise<IAPI_CON009_Response> => {
  let res = await http.post(ApiUrl.API_CON009, {
    ...param,
  });

  return res.data;
};

// 契約者氏名等変更届・共済契約証書再交付申出更新
const httpAPI_CON016 = async (
  param: IAPI_CON016_Request
): Promise<IAPI_CON016_Response> => {
  let res = await http.post(ApiUrl.API_CON016, {
    ...param,
  });

  return res.data;
};

export { httpAPI_CON009, httpAPI_CON016 };
